const userData = [
    { username: 'johnDoe_91', password: 'jd123'},
    { username: 'john', password: 'j123'},
    { username: 'doe', password: 'd123'}
]

export default userData